import { Component } from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import { LogoutButton } from "../../components/logoutBtn";

export class SupportNavbar extends Component {
    render() {
        return (<>
            <Navbar bg="dark" data-bs-theme="dark">
                <Container>
                    <Navbar.Brand>Teach Insights Support</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto">
                            </Nav>
                            <Nav>
                                <Nav.Link><LogoutButton /></Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                </Container>
            </Navbar>
            <Outlet />
        </>)
    }
}